import {
  Component,
  ChangeDetectionStrategy,
  Input,
  Output,
  EventEmitter
} from '@angular/core';
import { Integrante } from '../../../../roles/integrante/integrante.model';
import { NaturalezaJuridica } from '../../../entity-naturalezas-juridica/naturalezas-juridica.model';
import { Laboratorio } from '../../../../actividades/entity-laboratorios/laboratorios.model';
import { PersonasJuridica } from '../../../entity-personas-juridica/entity-personas-juridica.model';
import { Persona, TipoRol } from '@rpe/registro-personas-empresas-lib';
import { RegistroIntegranteUpdateFormComponent } from '../../../entity-registro-empresa/components/registro-integrante-update-form/registro-integrante-update-form.component';
import { MatDialog } from '@angular/material/dialog';
import { VistaMisIntegrantesInput } from '../../models/vista-mis-integrantes.models';
import { EntidadesProductiva } from '../../../entity-entidad-productiva/entity-entidades-productiva.model';
import { ConfirmDialogComponent } from 'projects/registro-personas-empresas/src/app/shared/confirm-dialog/confirm-dialog.component';
import { filter, take } from 'rxjs/operators';
import { EstadosRol } from "../../../../roles/entity-estado-rol/entity'estados-rol.models";
import { Rol } from '../../../../roles/entity-roles/roles.model';
import { Store } from '@ngrx/store';
import {
  selectAllRol,
  selectRolesPropios
} from '../../../../roles/entity-roles/entity-roles.selectors';
import { State } from '../../../../vista-usuario/vista-usuario.state';
import * as moment from 'moment';
import { entityRolChangeRequest } from '../../../../roles/entity-roles/entity-roles.actions';

@Component({
  selector: 'rpe-vista-mis-integrantes',
  templateUrl: './vista-mis-integrantes.component.html',
  styleUrls: ['./vista-mis-integrantes.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VistaMisIntegrantesComponent {
  @Input() set vistaMisIntegrantesInput(value: VistaMisIntegrantesInput) {
    if (value) {
      this.currentEmpresa = value.currentEmpresa;
      this.showIntegrantes = value.showIntegrantes;
      this.integrantes = value.integrantes;
      this.naturalezasJuridicas = value.naturalezasJuridicas;
      this.laboratorios = value.laboratorios;
      this.tiposRol = value.tiposRol;
      this.createdPersonaJuridica = value.createdPersonaJuridica;
      this.createdPersonaFisica = value.createdPersonaFisica;
      this.backUrl = value.backUrl;
      this.estadosRol = value.rolEstado;
    }
  }

  @Output() deleteIntegranteEvent: EventEmitter<Integrante> =
    new EventEmitter<Integrante>();

  showIntegrantes: boolean = false;

  integrantes: Integrante[] = [];
  naturalezasJuridicas: NaturalezaJuridica[] = [];
  laboratorios: Laboratorio[] = [];
  tiposRol: TipoRol[] = [];
  rolesPersona: Rol[] = [];
  currentEmpresa: EntidadesProductiva = null;
  estadosRol: EstadosRol[] = [];

  backUrl: string = '/empresas/mi-empresa';

  createdPersonaJuridica: PersonasJuridica = null;
  createdPersonaFisica: Persona | any = null;

  constructor(private dialog: MatDialog, private store: Store<State>) {}

  ngOnInit(): void {
    this.store.select(selectRolesPropios).subscribe((rolesPersona) => {
      this.rolesPersona = rolesPersona;
    });
  }

  isCreadorEmpresa(personaId: number): boolean {
    if (personaId === this.currentEmpresa?.usuario_creador_id) {
      return true;
    }

    return false;
  }

  updateIntegrante(integrante: Integrante): void {
    this.dialog.open(RegistroIntegranteUpdateFormComponent, {
      data: {
        integrante: integrante,
        laboratorios: this.laboratorios,
        personaJuridica: this.createdPersonaJuridica,
        personaFisica: this.createdPersonaFisica,
        naturalezasJuridicas: this.naturalezasJuridicas
      }
    });
  }

  deleteIntegrante(integrante: Integrante): void {
    const ref = this.dialog.open(ConfirmDialogComponent, {
      data: {
        title: 'Confirmación de eliminación',
        contentText: `¿Está seguro que desea eliminar el integrante ${
          integrante.nombre_completo
        } con el rol de ${this.findRol(integrante.rol.tipo_rol_id).nombre}?`,
        submitText: 'Eliminar',
        cancelText: 'Cancelar',
        cancelColor: 'primary'
      }
    });

    ref
      .afterClosed()
      .pipe(
        take(1),
        filter((result) => result === true)
      )
      .subscribe(() => {
        let rolToUpdate = { ...integrante.rol };

        if (integrante.rol.tipo_rol_id === 6) {
          const hayTecnicoResponsable = this.rolesPersona.some(
            (rol) =>
              rol.tipo_rol_id === 6 &&
              rol.entidad_productiva_id === integrante.rol.entidad_productiva_id
          );

          const hayAdministrativoResponsable = this.rolesPersona.some(
            (rol) =>
              rol.tipo_rol_id === 4 &&
              rol.entidad_productiva_id === integrante.rol.entidad_productiva_id
          );

          if (hayTecnicoResponsable) {
            rolToUpdate.vinculo_aprobado_rol = false;
          }

          if (hayAdministrativoResponsable && !hayTecnicoResponsable) {
            rolToUpdate.vinculo_aprobado_entidad_productiva = false;
          }
        }

        this.store.dispatch(
          entityRolChangeRequest({
            item: {
              ...rolToUpdate,
              fecha_baja: moment().format('YYYY-MM-DD')
            }
          })
        );
      });
  }

  findRol(id: number): TipoRol {
    return this.tiposRol.find((tipoRol) => tipoRol.id === id);
  }

  findRolState(id: number): string {
    return (
      this.estadosRol.find((estado) => estado.id === id)?.nombre ||
      'No asignado'
    );
  }

  buscarLaboratoriosById(ids?: number[]) {
    if (!ids) return [];
    return this.laboratorios.filter((l) => ids.includes(l.id));
  }
}
